export const SURVEY_CART_KEY = 'surveyCart';
export const SURVEY_CONTRACT_KEY = 'surveyContract';
